

































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { HeaderItem } from '@core/model/structure/HeaderStructure'
import { cid, container } from 'inversify-props'
import { IProjectSettings } from '@master/config/IProjectSettings'
import VideocamIcon from '@core/components/header/assets/videocam.svg'
import MenuIcon from '@core/components/header/assets/menu.svg'
import AppDialog from '@core/components/AppDialog.vue'

@Component({
  components: {
    AppDialog
  }
})
export default class AppDynamicHeader extends Vue {
  @Prop({ required: true }) private readonly header!: HeaderItem[]

  private jitsiUrl = ''
  private isJitsiUrlShow = false
  private isCopied = false
  private isShowMenu = false

  startVirtualMeeting () {
    this.jitsiUrl = 'https://meet.jit.si/' + this.randomStr(32)
    this.isJitsiUrlShow = true
  }

  randomStr (len: number) {
    const arr = '1234567890abcdefghijklmnopqrstuvwxyz'
    let ans = ''
    for (let i = len; i > 0; i--) {
      ans += arr[Math.floor(Math.random() * arr.length)]
    }
    return ans
  }

  copyUrl () {
    const url: HTMLInputElement = document.getElementById('url') as HTMLInputElement
    url.select()
    url.setSelectionRange(0, 99999)
    document.execCommand('copy')
    this.isCopied = true
  }

  get enableVirtualMeeting () {
    const { virtualMeeting } = container.get<IProjectSettings>(cid.IProjectSettings)
    return virtualMeeting ? virtualMeeting.enable : false
  }

  get videocamIcon () {
    return VideocamIcon
  }

  get menuIcon () {
    return MenuIcon
  }

  // Methods
  goToHome () {
    window.location.href = '/live/home'
  }
}
